<template>
    <div>
        <div v-if="!showWaybillDetail" href="#" class="clearfix toggle" @click="showTencentCaptcha()">
            <span class="fl">查看子单详情</span>
            <span class="fr"><icon name="arrow-down"></icon></span>
        </div>
        <div v-else>
            <p class="child-title">子单详情</p>
            <div v-for="childItem in showFetchList" :key="childItem">
                <div
                    v-if="
                        (waybillModel(childItem) && isAbroadRoute(waybillModel(childItem).routes)) ||
                        (waybillModel(childItem) &&
                            waybillModel(childItem).routes &&
                            waybillModel(childItem).routes.length > 0 &&
                            !isAbroadRoute(waybillModel(childItem).routes) &&
                            waybillModel(childItem).originOld &&
                            waybillModel(childItem).destinationOld)
                    "
                >
                    <waybill-info
                        :waybillModel="waybillModel(childItem)"
                        :getStatusByOpcode="getStatusByOpcode(waybillModel(childItem).routes[0])"
                        :isRootMenu="false"
                    ></waybill-info>
                    <waybill-route :routes="waybillModel(childItem).routes"></waybill-route>
                </div>
                <div v-else class="not-found">
                    <p class="title"><span class="text">运单号</span>{{ childItem }}</p>
                    <p>{{ `运单${childItem}未揽收或寄件时间超过3个月。` }}</p>
                    <p v-if="isAppleWaybill(childItem)">如有疑问，可致电顺丰客服热线4001288853</p>
                </div>
            </div>
            <p v-if="showFetchList.length < waybillNoList.length" class="child-fetch-more" @click.prevent="showTencentCaptcha()">
                <span>查看更多子单详情</span>
            </p>
            <p v-else class="child-no-more">没有更多子单详情了</p>
            <div class="clearfix toggle" @click="hideChildSet()">
                <span class="fl">收起子单详情</span>
                <span class="fr"><icon name="arrow-up"></icon></span>
            </div>
        </div>
    </div>
</template>

<script>
import rootChildCommon from '@/mixins/waybill/rootChildCommon'
export default {
    name: 'WaybillChild',
    mixins: [rootChildCommon],
    props: {
        waybillNoList: {
            // 父组件传过来的子单号数组
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            needFetchList: [],
            showFetchList: []
        }
    },
    created() {
        const count = Math.ceil(this.waybillNoList.length / 20)
        for (let i = 0; i < count; i++) {
            this.needFetchList.push(this.waybillNoList.slice(i * 20, (i + 1) * 20))
        }
    },
    methods: {
        // 调用滑块验证
        showTencentCaptcha() {
            if (_webconfig.useTencentCaptcha == true) {
                const tempList = this.needFetchList.shift()
                this.showFetchList = this.showFetchList.concat(tempList)
                this.$parent.showTencentCaptcha(this.query, tempList)
            } else {
                this.query()
            }
        },
        // 收起子单详情
        hideChildSet() {
            this.showWaybillDetail = false
        },
        isAppleWaybill(waybillNo) {
            const no = waybillNo.toString()
            return no.startsWith('960') || no.startsWith('SF960')
        }
    }
}
</script>

<style lang="scss" scoped>
.toggle {
    display: block;
    color: $gray;
    font-size: 25px;
    padding: 15px 20px;
    background: $bg-color;
    margin-bottom: 50px;
    border-radius: 4px;
    .icon-arrow-down,
    .icon-arrow-up {
        height: 30px;
    }
}
.child-title {
    height: 50px;
    line-height: 50px;
    font-size: 35px;
    padding-left: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    border-left: 6px solid $red;
}
.not-found {
    background: $bg-color;
    color: $gray;
    font-size: 25px;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    .title {
        .text {
            margin-right: 15px;
        }
        font-size: 35px;
        color: $black;
        margin-bottom: 35px;
    }
}
.child-fetch-more,
.child-no-more {
    height: 40px;
    line-height: 0.4rem;
    text-align: center;
    font-size: 13px;
}
.child-no-more {
    color: #999;
}
.child-fetch-more {
    span {
        font-size: 13px;
        cursor: pointer;
        color: red;
        text-decoration: underline;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/waybill/waybillDetail/waybill-child.vue